module.exports = __webpack_public_path__ + "img/3.77c69560.svg";